import React from 'react';
import BioTemplateClassic from './BioTemplateClassic';
import BioTemplateModern from './BioTemplateModern';
import BioTemplateMinimal from './BioTemplateMinimal';
import BioTemplateCreative from './BioTemplateCreative';
import BioTemplateProfessional from './BioTemplateProfessional';
import BioTemplateGradient from './BioTemplateGradient';
import BioTemplateExecutive from './BioTemplateExecutive';

const BioTemplateRenderer = ({ card, bioUrl, constructSocialUrl, trackLinkClick, onQRClick, hideQR = false, isOwner = false, onUpdateProfileImage, onUpdateLogo, isPremium = false }) => {
  // Get the template from card.bioTemplate, default to 'classic'
  const templateId = card?.bioTemplate || 'classic';

  // Map template IDs to components
  const templates = {
    classic: BioTemplateClassic,
    modern: BioTemplateModern,
    minimal: BioTemplateMinimal,
    creative: BioTemplateCreative,
    professional: BioTemplateProfessional,
    gradient: BioTemplateGradient,
    executive: BioTemplateExecutive
  };

  // Get the selected template component, fallback to classic if not found
  const TemplateComponent = templates[templateId] || templates.classic;

  // For non-premium users, use Piper Card logo instead of their uploaded logo
  const displayCard = isPremium ? card : {
    ...card,
    companyLogo: '/logo.png' // Use Piper Card logo for free users
  };

  // Render the selected template
  return (
    <TemplateComponent 
      card={displayCard}
      bioUrl={bioUrl}
      constructSocialUrl={constructSocialUrl}
      trackLinkClick={trackLinkClick}
      onQRClick={onQRClick}
      hideQR={hideQR}
      isOwner={isOwner}
      onUpdateProfileImage={onUpdateProfileImage}
      onUpdateLogo={onUpdateLogo}
      isPremium={isPremium}
    />
  );
};

export default BioTemplateRenderer;